import React, {useContext, useEffect, useMemo, useRef, useState} from 'react'
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo} from "@propelauth/react";
import {useNavigate} from "react-router-dom";
import {API_URL, fetchWithToken, patchWithToken} from "../../api/apiBase";
import {Button} from "../ui/button";
import {UserContext} from "../../contexts/UserContext";
import {Input} from "../ui/input";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import {CompanyType} from "../../models/company";
import {Label} from "../ui/label";
import {useToast} from "../ui/use-toast";
import MapComponent from "../googleMaps/MapComponent";
import {FormProvider, useForm} from "react-hook-form";
/// import {Project} from "@models/project";
import {Address} from "@models/base";
import {FormControl, FormField, FormItem, FormLabel} from "../ui/form";
import {Autocomplete, Libraries, useJsApiLoader} from "@react-google-maps/api";
import {handleAddressChanged} from "../googleMaps/handleChangheAddress";
import {userLocation} from "../googleMaps/userLocationModel";
import { useGoogleMapsAutocomplete } from "../../hooks/useGoogleMapsAutocomplete";
import { Spinner } from '../ui/spinner';
// import {
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "../ui/form";

type CompanySetupSchema = {
    company_type: string
    name: string
}


const _developerInfoText = "I am developing a project, I am looking for builders to bid on my project";
const _builderInfoText = "I am a builder, I am looking for projects to bid on";


function AddressForm() {
    const form = useForm<Address>({
        defaultValues: {
            address: ""
          } as userLocation,
    })

    const userContext = useContext(UserContext);
    const [open, setOpen] = useState(false);

    const [location, setLocation] = useState<userLocation>({
        address: "",
    });

    const { autocompleteAddressRef, isLoaded, loadError } = useGoogleMapsAutocomplete();

    const onSubmit = (e: Address) => {
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            (e.target as HTMLInputElement).blur();
        }
    };
    return (<div>
        {/*<MapComponent userLocation={}/>*/}
        <FormProvider {...form}>
            <form
                onSubmit={form.handleSubmit(onSubmit)}
                className="grid grid-cols-2 gap-x-14 gap-y-4"
            >
                <div>
                    <FormField
                        name="address.country"
                        render={({field}) => (
                            <FormItem>
                                <FormLabel>Address</FormLabel>
                                <FormControl>

                                    <Autocomplete
                                        onLoad={(autocomplete) =>
                                            (autocompleteAddressRef.current = autocomplete)
                                        }
                                        onPlaceChanged={() =>
                                            handleAddressChanged(
                                                field,
                                                setLocation,
                                                autocompleteAddressRef
                                            )
                                        }
                                    >
                                        <Input
                                            className="w-full"
                                            placeholder="Select Country"
                                            {...field}
                                            value={field.value || ""}
                                            onKeyDown={handleKeyDown}
                                            onBlur={(e) => {
                                                const newValue = e.target.value;
                                                setLocation((prev) => ({
                                                    ...prev,
                                                    address: newValue,
                                                }));
                                            }}
                                        />
                                    </Autocomplete>

                                </FormControl>
                            </FormItem>)}
                    />
                    <div className="min-w-full mt-4 mb-4">
                        {!isLoaded ? (
                            <div>
                            <Spinner className="size-16 text-gray-300">
                                <span className="text-lg text-gray-800 animate-pulse font-medium">
                                Map loading, please wait...
                                </span>
                            </Spinner>
                        </div>
                        ) : (
                            <MapComponent userLocation={location} setValue={form.setValue}/>
                        )}
                        {loadError && <div>Error to load Map</div>}
                    </div>
                </div>
            </form>
        </FormProvider>
    </div>)
}


type CompanyListProps = {
    onSelect: (companyCard: any) => void;
    items: any[]
}

function PotentialCompaniestoJoin(props: CompanyListProps) {
    return (<>
            <br/>
        <Card className="w-1/2">
            <CardHeader><CardTitle>Potential Matches:</CardTitle></CardHeader>
        <CardContent>{props.items.map((item) =>
        <div key={item.id} className="flex justify-between">
            <Button variant="outline" onClick={(e) =>props.onSelect(item)}> Select</Button>
            <span>{item.name}</span>
            <span>{item.company_type}</span>
        </div>
    )}</CardContent>
            </Card>
        </>
    )
}

/**
 *
 * */
function CompanySetup(props: WithLoggedInAuthInfoProps) {

    const userContext = useContext(UserContext);
    const {toast} = useToast()

    // arriving from a bulk invite link: /company-setup?as=builder&next=/invite/<token>
    // 'as' locks the company type, 'next' is where we send them once set up.
    const inviteParams = useMemo(() => {
        const q = new URLSearchParams(window.location.search);
        const next = q.get('next');
        return {
            forcedType: q.get('as') === 'builder' ? CompanyType.builder : null,
            // only same-origin paths, so this cannot become an open redirect
            next: next && next.startsWith('/') && !next.startsWith('//') ? next : null,
        };
    }, []);

    const [company_id, setCompanyId] = useState<string | null>(null)
    const [companyType, setCompanyType] = useState<CompanyType>(
        inviteParams.forcedType ?? CompanyType.not_set)
    const [company_name, setCompanyName] = useState<string>('');

    const [message, setMessage] = useState<string>('');
    const [companyMatches, setCompanyMatches] = useState<any[]>([])
    //
    const [editDisabled, setEditDisabled] = useState<boolean>(false);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);


    const canSubmit = (companyType === CompanyType.developer || companyType === CompanyType.builder)
        && submitDisabled === false
        && (companyMatches?.some((x, _) => x.name.toLowerCase() === company_name.toLowerCase()) === false)
        && company_name?.length > 0;

    const navigate = useNavigate();

    const resetStuff = () => {
        setCompanyId(null);
        setMessage("");
    }

    useEffect(() => {
        if(companyType && company_name && (companyType !== CompanyType.not_set) && company_name.length >= 3 && company_id === null) {
            setSubmitDisabled(true)
            setCompanyMatches([])
            setMessage("")

            fetchWithToken(`/company/check_org/${company_name}/${companyType}`, props.accessToken)
                .then((result) => {
                    console.log(result.status_code, result);
                    if (result.status_code === 'DOMAIN_MATCH') {
                        setEditDisabled(true);
                        setCompanyName(result.name);
                        setCompanyId(result.company_id);
                        setCompanyType(result.company_type);
                        setMessage(result.message);

                    } else if (result.status_code == 'NAME_MATCH') {
                        setCompanyMatches(result.items)
                        if(companyMatches.some((x, _) => x.name.toLowerCase() === company_name.toLowerCase())){
                            setMessage("A company with that name already exists. " +
                                "Request to join the company or chose a different name")
                        }


                    } else if (result.status_code == 'NO_MATCH') {
                        // pass
                        resetStuff();
                    } else {
                        // pass
                        resetStuff();
                    }
                    setSubmitDisabled(false)
                }).catch((err) => {
                console.log(err);
                    setSubmitDisabled(false)
            })
        }
    }, [company_name, companyType])

    const handleDeveloperSelect = () => {
        setCompanyType(CompanyType.developer);
        resetStuff();
    }

    const handleBuilderSelect = () => {
        setCompanyType(CompanyType.builder);
        resetStuff();
    }

    const handleCompanySelect = (companyCard:any) => {

        setCompanyType(companyCard.company_type);
        setCompanyName(companyCard.name);
        setCompanyId(companyCard.id);
        setSubmitDisabled(false)
        setMessage("")
        console.log("join", companyCard);
    }

    const displaySetting = () => {
        if (companyType === CompanyType.developer) {
            return "Setup company as Developer"
        } else if (companyType === CompanyType.builder) {
            return "Setup company as Builder"
        } else {
            return "Select Developer or Builder"
        }
    }

    const handleContinue = () => {
        console.log('company_type', companyType, company_name)
        if (canSubmit && !company_id) {
            setSubmitDisabled(true)
            patchWithToken( `/company/create_new`,
                JSON.stringify({company_type: companyType, name: company_name}),
                props.accessToken)
                .then((data) => {
                    setSubmitDisabled(false)
                    // api call to setup the company.
                    console.log('data', data)
                    if (data.message) {
                        toast({
                            title: "Error",
                            description: data.message,
                            variant: "destructive",
                        });
                        navigate('/',)
                    } else {
                        // then navigate to home...
                        // in theory, we return the page we navigate to next from api ...
                        toast({
                            title: "Success!",
                            description: "Company updated. ",
                            variant: "default",
                        });
                        if (inviteParams.next) {
                            // back to the bulk invite page to pick scopes
                            window.location.replace(inviteParams.next);
                        } else if (data.redirect_to) {
                            window.location.replace(data.redirect_to);
                        } else {
                            // just in case ... we navigate to home
                            navigate('/')
                            // window.location.reload();
                        }
                    }
                    // window.location.reload() // this is a hack
                })
                .catch((error) => {
                    console.log('error', error)
                    setSubmitDisabled(false)
                    toast({
                        title: "Error",
                        duration: 5000,
                        description: error.message || "Failed to fetch",
                        variant: "destructive",
                    });
                })
        } else { }
    }

    const handleRequestJoin = () => {
        console.log(company_id);
        if ( company_id) {
            setSubmitDisabled(true);
            patchWithToken(
                `/company/request_join`,
                JSON.stringify({company_type: companyType, name: company_name, company_id: company_id}),
                props.accessToken,)
                .then((data) => {
                    setSubmitDisabled(false)
                    // api call to setup the company.
                    console.log('Company reqiest_join', data)
                    if (data.message) {
                        toast({
                            title: "Error",
                            description: data.message,
                            variant: "destructive",
                        });
                        navigate('/',)
                    } else {
                        // then navigate to home...
                        // in theory, we return the page we navigate to next from api ...
                        toast({
                            title: "Success!",
                            description: "Company updated. ",
                            variant: "default",
                        });
                        if (inviteParams.next) {
                            window.location.replace(inviteParams.next);
                        } else if (data.redirect_to) {
                            console.log('redirect to ', data.redirect_to);
                            window.location.replace(data.redirect_to);
                        } else {
                            console.log('reload');
                            window.location.reload();
                        }
                    }
                })
                .catch((error) => {
                    console.log('error', error)
                    setSubmitDisabled(false);
                    toast({
                        title: "Error",
                        duration: 5000,
                        description: error.message || "Failed to fetch",
                        variant: "destructive",
                    });
                })
        } else {

        }
    }

    const handleInput = (value:string) => {
        setCompanyId(null);
        setCompanyName(value);
    }

    // console.log(company_id)
    return <div className="grid justify-items-center">
        <Card className="w-1/2">
            <CardHeader></CardHeader>
            <CardContent>
                {message ? <div className="text-sm">{message}<br/><br/></div> : <></>}

                <Label>Company Name *</Label>
                <Input
                    disabled={editDisabled}
                    className="w-full"
                    placeholder="Enter Company Name"
                    value={company_name}
                    onChange={(e) =>{
                        const sanitized = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                        handleInput(sanitized)
                    }
                }
                />
                <br/>
                <Label className="flex justify-center gap-3">I am A... *</Label>
                {inviteParams.forcedType
                    ? <div className="flex justify-center text-sm">Builder</div>
                    : <div className="flex justify-center">

                    <Button variant={companyType === CompanyType.developer ? "default" : "outline"}
                            className="mr-2"
                            disabled={editDisabled}
                            onClick={() => handleDeveloperSelect()}
                    >Developer
                    </Button>

                    <Button variant={companyType === CompanyType.builder ? "default" : "outline"}
                            className="mr-2"
                            disabled={editDisabled}
                            onClick={() => handleBuilderSelect()}
                    >Builder
                    </Button>
                </div>}
                <div className='text-sm flex justify-center mr-1'> {displaySetting()}</div>

                <br/>
                {company_id

                    ?<Button
                        onClick={() => handleRequestJoin()}
                      >Request to Join Company</Button>

                    :<Button
                        onClick={() => handleContinue()}
                        disabled={!canSubmit}
                    >Create New Company</Button>}
            </CardContent>
        </Card>
        {companyMatches.length >0
            ? <PotentialCompaniestoJoin
                items={companyMatches}
                onSelect={handleCompanySelect}/>
            : <></>
        }
    </div>
}

export default withRequiredAuthInfo(CompanySetup)